import React from "react";
import { Row, Col, Tooltip } from "antd";
import { Info } from "@material-ui/icons";
import { dirname } from "util/resourcePath";
import { file } from "jszip";

const directory = dirname();

export const calendarCSVUploadConfig = {
  modal: {
    title: () => (
      <>
        Calendar CSV Upload Instructions
      </>
    ),
    content: () => (
      <>
        <p>
          Please upload a CSV file containing holiday data. The file must have the following columns:
        </p>
        <ul>
          <li><strong>date</strong>: The date of the holiday in YYYY-MM-DD format.</li>
          <li><strong>name</strong>: The description of the holiday in English.</li>
        </ul>
        <p>
          Example:
        </p>
        <pre>
{`date,name
2026-01-01,New Year's Day
2026-12-25,Christmas Day`}
        </pre>
      </>
    ),
  },
  form: {
    title: "Calendar CSV Upload",
    description: "Upload a CSV file with holiday data.",
    upload: {
      uploadUrl: "/invoice/calendar_csv_upload",
      maxCount: 1,
      accept: ".csv",
      isInvalid: (file) => {
        const fileName = file.name.toLowerCase();
        const isCSV = fileName.endsWith(".csv");

        if (!isCSV) {
          return "You can only upload CSV files!";
        }

        // Check file size (5MB limit)
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          return "File size must be smaller than 5MB!";
        }

        return null;
      },
    },
  },
};